export default "__VITE_ASSET__DT6xBg9___"